import React from 'react';

import Text from '../../shared/Typography';

type Props = {
  children: any
}

const CodeBlock = (props: Props) => {
  return (
    <pre className='pattern-library__code-block'>
      <Text code>{props.children}</Text>
    </pre>
  );
};

export default CodeBlock;


// WEBPACK FOOTER //
// ./src/components/pages/pattern-library/CodeBlock.js